export default __webpack_public_path__ + "static/media/tuto-step-1.d0ae2a59.gif";